import React from 'react';
import { css, StyleSheet } from 'aphrodite';

export default class DropDownSelectAll extends React.Component {
  render() {
    return (
      <div className={`${css(styles.checkbox)}`}>
        <label className={`cps-checkbox-large`}>
          <input
            checked={this.props.checked}
            onClick={e => {
              this.props.toggleSelectAll(e.target.checked);
            }}
            type={'checkbox'}
          />
          <span className={`cps-body-sm`}>Select All</span>
        </label>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  checkbox: {
    display: 'flex',
    justifyContent: 'start',
    marginBottom: '16px',
    alignItems: 'center',
  },
});
